/**
 * "My profile photo changed" — one in-page signal from the upload to every
 * place that shows the signed-in user's own photo.
 *
 * The header reads the photo once per sign-in and the helper dashboard serves
 * its profile from a short module cache, so after an upload both kept showing
 * the old (often missing) photo until a full reload. ProfileSection, the only
 * upload path, announces the new URL here; the readers update in place.
 */

const EVENT = 'kanfy:avatar-updated';

interface AvatarUpdatedDetail {
  userId: string;
  avatarUrl: string;
}

export function announceAvatarUpdated(userId: string, avatarUrl: string): void {
  window.dispatchEvent(new CustomEvent<AvatarUpdatedDetail>(EVENT, { detail: { userId, avatarUrl } }));
}

/** Subscribe to photo changes for one user; returns the unsubscribe. */
export function onAvatarUpdated(userId: string, handler: (avatarUrl: string) => void): () => void {
  const listener = (event: Event) => {
    const detail = (event as CustomEvent<AvatarUpdatedDetail>).detail;
    if (detail?.userId === userId && detail.avatarUrl) handler(detail.avatarUrl);
  };
  window.addEventListener(EVENT, listener);
  return () => window.removeEventListener(EVENT, listener);
}
